let loaded = false;

export const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const loadGA = () => {
  if (loaded || !GA_ID) return;
  loaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
};

export const trackPageView = (path) => {
  if (loaded && window.gtag && GA_ID) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
    });
  }
};

export const isGaLoaded = () => loaded;
